import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';

export const PackageTypeLabel = () => <FormattedMessage {...messages.customPackageType} />;
